import * as DescriptionActions from '../actions/description.actions';

const defaultFilter = {
  PatientGroupIds: [],
  PackType: ['0'],
  SortField: 'PatientName',
  SortOrder: 1,
};

const initialState = {
  loading: false,
  updating: false,
  error: null,
  data: [],
  total: 0,
  filter: defaultFilter,
  selectedDrugCodes: [],
  prescriptionDescriptions: {}, // drugCode -> description mapping
};

const description = (state = initialState, action) => {
  switch (action.type) {
    case DescriptionActions.GET_PRESCRIPTION_LIST: {
      return { ...state, loading: true, error: null };
    }
    case DescriptionActions.GET_PRESCRIPTION_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        total: action.payload.total,
        error: null,
      };
    }
    case DescriptionActions.GET_PRESCRIPTION_LIST_FAIL: {
      return { ...state, loading: false, error: action.payload.message };
    }
    case DescriptionActions.UPDATE_PRESCRIPTION_DESCRIPTIONS: {
      return { ...state, updating: true, error: null };
    }
    case DescriptionActions.UPDATE_PRESCRIPTION_DESCRIPTIONS_SUCCESS: {
      return {
        ...state,
        updating: false,
        error: null,
        selectedDrugCodes: [],
        prescriptionDescriptions: {},
      };
    }
    case DescriptionActions.UPDATE_PRESCRIPTION_DESCRIPTIONS_FAIL: {
      return { ...state, updating: false, error: action.payload.message };
    }
    case DescriptionActions.SET_DESCRIPTION_FILTER: {
      return { ...state, filter: { ...state.filter, ...action.payload.filter } };
    }
    case DescriptionActions.RESET_DESCRIPTION_FILTER: {
      return { ...state, filter: defaultFilter };
    }
    case DescriptionActions.SET_SELECTED_PRESCRIPTIONS: {
      return { ...state, selectedDrugCodes: action.payload.selectedIds };
    }
    case DescriptionActions.UPDATE_PRESCRIPTION_DESCRIPTION: {
      const { prescriptionId: drugCode, description: desc } = action.payload;
      return {
        ...state,
        prescriptionDescriptions: {
          ...state.prescriptionDescriptions,
          [drugCode]: desc,
        },
      };
    }
    default: {
      return state;
    }
  }
};

export default description;